export interface InferenceHollowAsset {
  readonly key: string; readonly path: string; readonly width: number; readonly height: number;
  readonly alpha: boolean; readonly required: true;
}

const ROOT = 'assets/story-forest/inference-hollow';
const image = (key: string, path: string, width: number, height: number, alpha: boolean): InferenceHollowAsset => ({
  key, path: `${ROOT}/${path}`, width, height, alpha, required: true,
});

export const INFERENCE_HOLLOW_ASSETS = {
  dormant: image('inference-hollow-dormant', 'backgrounds/inference-hollow-dormant.png', 1280, 720, false),
  restored: image('inference-hollow-restored', 'backgrounds/inference-hollow-restored.png', 1280, 720, false),
  clueLantern: image('inference-hollow-clue-lantern', 'interactives/clue-lantern.png', 512, 512, true),
} as const;

export const INFERENCE_HOLLOW_ASSET_LIST = Object.values(INFERENCE_HOLLOW_ASSETS);
export const INFERENCE_HOLLOW_PRODUCTION_READY = true;

export function preloadInferenceHollowAssets(scene: Phaser.Scene) {
  INFERENCE_HOLLOW_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingInferenceHollowAssets(textures: Phaser.Textures.TextureManager) {
  return INFERENCE_HOLLOW_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterInferenceHollow(textures: Phaser.Textures.TextureManager) {
  return INFERENCE_HOLLOW_PRODUCTION_READY && getMissingInferenceHollowAssets(textures).length === 0;
}
